import { padStart } from 'lodash';

const TIMER_START_DURATION = 5 * 60; // 5 minutes

export const reservationTimerMixin = {
  data() {
    return { timer: TIMER_START_DURATION };
  },

  mounted() {
    setInterval(() => {
      this.timer -= 1;
    }, 1000);
  },

  computed: {
    timerString() {
      if (this.timer <= 0) {
        return 'Your order reservation has expired! Refresh the page to reserve your item again.';
      }

      const minutes = Math.floor(this.timer / 60);
      const seconds = this.timer - minutes * 60;

      const timeLeftString =
        padStart(minutes, 2, '0') + ':' + padStart(seconds, 2, '0');

      return `Your order is reserved for ${timeLeftString} minutes!`;
    },
  },
};
